export enum CredentialTypeEnum {
    Email = 0,
    Office365 = 1,
    Office365B =2,
    OneDrive=3,
    PowerBI=4,
    Visio=5,
    ProjectPlan=6
}
